import { render, staticRenderFns } from "./CartHeaders.vue?vue&type=template&id=567520a9&lang=pug&"
import script from "./CartHeaders.vue?vue&type=script&lang=js&"
export * from "./CartHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CartHeaders.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VListTile,
})
